import { useTranslation } from 'react-i18next'

import { ProgramDetailTable } from './Shared/ProgramDetailTable'
import { ProgramDetailRow } from './Shared/ProgramDetailRow'
import { AgentVerificationCheck } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import { Flex, Typography } from '@percent/lemonade'

export function ProgramAgentVerificationDetails({
  associationChecks,
  identityChecks,
  isStatusDynamic
}: Readonly<AgentVerificationCheck>) {
  const { t } = useTranslation()

  return (
    <Flex gap={16} direction="column">
      <Typography variant="h4">{t('typography.agentVerification')}</Typography>
      <ProgramDetailTable
        title={t('program.label.identityChecks')}
        items={identityChecks?.map(({ type }) => t(`program.label.identityChecks.${type}`))}
        status="on"
      />
      <ProgramDetailTable
        title={t('program.label.associationChecks')}
        items={associationChecks?.map(({ type }) => t(`program.label.associationChecks.${type}`))}
        status="on"
      />
      <ProgramDetailRow title={t('program.label.dynamicStatus')} status={isStatusDynamic ? 'on' : 'off'} />
    </Flex>
  )
}
